/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Ai_FcInputs */

const en_fc_cmp_ai_fc = /** @type {(inputs: Fc_Cmp_Ai_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Few so far (optional speech-to-text); scriptable via CLI / MCP`)
};

/**
* | output |
* | --- |
* | "Few so far (optional speech-to-text); scriptable via CLI / MCP" |
*
* @param {Fc_Cmp_Ai_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_ai_fc = /** @type {((inputs?: Fc_Cmp_Ai_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Ai_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_ai_fc(inputs)
});
export { fc_cmp_ai_fc as "fc.cmp.ai.fc" }